import { FC } from 'react';

import { EvTable } from '@evinced-private/ui-common';

import { LABEL_MANAGEMENT_PANEL_VALUES_TABLE_DAID } from 'data-automation-ids/LabelManagementAutomationIds';

import {
	VALUES_TABLE_DEFAULT_SORTED,
	VALUES_TABLE_ID,
	VALUES_TABLE_PAGE_SIZE
} from './ValuesTable.constants';
import { VALUES_TABLE_LABELS } from './ValuesTable.labels';
import { ValuesTableProps } from './ValuesTable.types';
import { getValuesTableColumns } from './ValuesTable.utils';
import { ValuesTableEmptyState } from './ValuesTableEmptyState';

import './ValuesTable.scss';

export const ValuesTable: FC<ValuesTableProps> = ({
	values,
	showDashboardVisibility = false,
	onRemoveValue,
	onToggleDashboardVisibility
}) => {
	const columns = getValuesTableColumns(
		showDashboardVisibility,
		onRemoveValue,
		onToggleDashboardVisibility
	);

	return (
		<EvTable
			dataAutomationId={LABEL_MANAGEMENT_PANEL_VALUES_TABLE_DAID}
			tableData={values}
			totalCount={values.length}
			showInfoRow={false}
			columns={columns}
			noDataIndicationMessage={<ValuesTableEmptyState />}
			options={{
				keyField: 'value',
				title: VALUES_TABLE_LABELS.TABLE_TITLE,
				caption: VALUES_TABLE_LABELS.TABLE_CAPTION,
				dataType: VALUES_TABLE_ID,
				defaultSorted: VALUES_TABLE_DEFAULT_SORTED,
				pagination: true,
				localProps: {
					defaultPage: 1,
					defaultSizePerPage: VALUES_TABLE_PAGE_SIZE
				}
			}}
		/>
	);
};
